module.exports = __webpack_public_path__ + "static/media/weibo.92ba3756.svg";